import TopPick from "../TopPick";

interface VideoProps {
  accountId: string;
  playerId: string;
  videoId: string;
  thumbnailUrl?: string;
  topPick?: boolean;
  overviewTitle: string;
  overviewDescription: string;
}

const Video = ({
  accountId,
  playerId,
  videoId,
  topPick,
  overviewTitle,
  overviewDescription,
}: VideoProps) => {
  return (
    <div className="lc-w-full lc-flex-1">
      <div className="lc-relative lc-w-full lc-aspect-video lc-overflow-hidden">
        {topPick && <TopPick />}
        <iframe
          className="lc-top-8 lc-left-0 lc-w-full lc-h-full lc-aspect-video"
          src={`https://players.brightcove.net/${accountId}/${playerId}_default/index.html?videoId=${videoId}`}
          frameborder="0"
          allow="encrypted-media"
          allowFullScreen
          title="YouTube video player"
        />
      </div>
      <div className="lc-flex lc-flex-col lc-text-white lc-bg-cfa-blue-975 lc-p-4">
        <p className="lc-font-bold lc-text-2xl">{overviewTitle}</p>
        <p className="lc-mt-2 lc-text-md">{overviewDescription}</p>
      </div>
    </div>
  );
};
export default Video;
